import { Repeat, Repeat1 } from 'lucide-react';
import type { RepeatMode } from '../../../../context/PlayerContext';
import './LoopButton.css';

type Props = {
    mode: RepeatMode;
    onClick: () => void;
};

const LABELS: Record<RepeatMode, string> = {
    off: 'Enable repeat',
    all: 'Repeat all (click for repeat one)',
    one: 'Repeat one (click to turn off)',
};

export function LoopButton({ mode, onClick }: Props) {
    const Icon = mode === 'one' ? Repeat1 : Repeat;
    return (
        <button
            className={`loopButton ${mode !== 'off' ? 'loopButtonActive' : ''}`}
            onClick={onClick}
            aria-label={LABELS[mode]}
            aria-pressed={mode !== 'off'}
        >
            <Icon size={16} strokeWidth={2.75} />
        </button>
    );
}
